import {
  Instant as Instant,
  Clock as Clock,
  Duration as Duration,
} from '@js-joda/core';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  multiply2k9eolhnz1bjv as multiply,
  subtract2orl8z9upxd9l as subtract,
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException } from './JSJodaExceptions.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from './Exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Formats_getInstance1ivgshh4uvub1 as Formats_getInstance } from './format/DateTimeComponents.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { safeAdd2ojtf0puot5k0 as safeAdd } from './internal/mathJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  _Duration___get_inWholeSeconds__impl__hpy7b32fu0rnoit26fw as _Duration___get_inWholeSeconds__impl__hpy7b3,
  _Duration___get_nanosecondsComponent__impl__nh19kq1udaeb2ce31e1 as _Duration___get_nanosecondsComponent__impl__nh19kq,
  Duration__isPositive_impl_tvkkt22mscvvkiz7i1u as Duration__isPositive_impl_tvkkt2,
  Duration__unaryMinus_impl_x2k1y03dvxfmeyyyudl as Duration__unaryMinus_impl_x2k1y0,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration__plus_impl_yu9v8f2gb5hwgakp0dd as Duration__plus_impl_yu9v8f,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  DurationUnit_NANOSECONDS_getInstancexzp0zqz7eqak as DurationUnit_NANOSECONDS_getInstance,
} from '../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from './serializers/InstantSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlinx.datetime.jsTry' call
        var tmp$ret$1 = Instant.ofEpochSecond(toNumber(-3217862419201n), 999999999);
        tmp.e1m_1 = new (Instant_0())(tmp$ret$1);
        var tmp_0 = this;
        // Inline function 'kotlinx.datetime.jsTry' call
        var tmp$ret$3 = Instant.ofEpochSecond(toNumber(3093527980800n), 0);
        tmp_0.f1m_1 = new (Instant_0())(tmp$ret$3);
        this.g1m_1 = new (Instant_0())(Instant.MIN);
        this.h1m_1 = new (Instant_0())(Instant.MAX);
      }
      d1m() {
        return new (Instant_0())(Clock.systemUTC().instant());
      }
      q26(epochMilliseconds) {
        var tmp;
        try {
          // Inline function 'kotlin.Long.div' call
          var tmp_0 = divide(epochMilliseconds, fromInt(1000));
          // Inline function 'kotlin.Long.rem' call
          // Inline function 'kotlin.Long.times' call
          var this_0 = modulo(epochMilliseconds, fromInt(1000));
          var tmp$ret$2 = multiply(this_0, fromInt(1000000));
          tmp = this.cv(tmp_0, tmp$ret$2);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var e = $p;
            if (!isJodaDateTimeException(e))
              throw e;
            tmp_1 = epochMilliseconds > 0n ? this.h1m_1 : this.g1m_1;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      r26(input, format) {
        var tmp;
        try {
          tmp = format.ev(input).h1s();
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw DateTimeFormatException().b1o("Failed to parse an instant from '" + toString(input) + "'", e);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      i25(input, format, $super) {
        format = format === VOID ? Formats_getInstance().p1r_1 : format;
        return $super === VOID ? this.r26(input, format) : $super.r26.call(this, input, format);
      }
      cv(epochSeconds, nanosecondAdjustment) {
        var tmp;
        try {
          // Inline function 'kotlin.floorDiv' call
          var other = 1000000000n;
          var q = divide(nanosecondAdjustment, other);
          if ((nanosecondAdjustment ^ other) < 0n && !(multiply(q, other) === nanosecondAdjustment)) {
            var _unary__edvuaz = q;
            q = subtract(_unary__edvuaz, get_ONE());
          }
          var tmp$ret$0 = q;
          var secs = safeAdd(epochSeconds, tmp$ret$0);
          // Inline function 'kotlin.mod' call
          var other_0 = 1000000000n;
          var r = modulo(nanosecondAdjustment, other_0);
          var tmp$ret$1 = add(r, other_0 & shiftRight((r ^ other_0) & (r | negate(r)), 63));
          var nos = convertToInt(tmp$ret$1);
          // Inline function 'kotlinx.datetime.jsTry' call
          var tmp$ret$3 = Instant.ofEpochSecond(toNumber(secs), nos);
          tmp = new (Instant_0())(tmp$ret$3);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            var tmp_1;
            if (!isJodaDateTimeException(e)) {
              tmp_1 = !(e instanceof ArithmeticException());
            } else {
              tmp_1 = false;
            }
            if (tmp_1)
              throw e;
            tmp_0 = epochSeconds > 0n ? this.h1m_1 : this.g1m_1;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      dv(epochSeconds, nanosecondAdjustment) {
        var tmp;
        try {
          // Inline function 'kotlinx.datetime.jsTry' call
          var tmp$ret$1 = Instant.ofEpochSecond(toNumber(epochSeconds), nanosecondAdjustment);
          tmp = new (Instant_0())(tmp$ret$1);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (!isJodaDateTimeException(e))
              throw e;
            tmp_0 = epochSeconds > 0n ? this.h1m_1 : this.g1m_1;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var InstantClass;
function Instant_0() {
  if (InstantClass === VOID) {
    class $ {
      constructor(value) {
        Companion_getInstance_0();
        this.n1s_1 = value;
      }
      o1s() {
        return numberToLong(this.n1s_1.epochSecond());
      }
      s26() {
        return numberToInt(this.n1s_1.nano());
      }
      t26() {
        // Inline function 'kotlin.Long.times' call
        var this_0 = this.o1s();
        var tmp0 = multiply(this_0, fromInt(1000));
        // Inline function 'kotlin.Long.plus' call
        var other = this.s26() / 1000000 | 0;
        return add(tmp0, fromInt(other));
      }
      u26(duration) {
        // Inline function 'kotlin.time.Duration.toComponents' call
        var tmp0 = _Duration___get_inWholeSeconds__impl__hpy7b3(duration);
        var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(duration);
        var tmp;
        try {
          tmp = new (Instant_0())(this.v26(toNumber(tmp0), nanoseconds));
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (!isJodaDateTimeException(e))
              throw e;
            tmp_0 = Duration__isPositive_impl_tvkkt2(duration) ? Companion_getInstance_0().h1m_1 : Companion_getInstance_0().g1m_1;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      v26(seconds, nanos) {
        var newSeconds = this.n1s_1.epochSecond() + seconds;
        var newNanos = this.n1s_1.nano() + nanos;
        // Inline function 'kotlinx.datetime.jsTry' call
        return Instant.ofEpochSecond(newSeconds, numberToInt(newNanos));
      }
      w26(duration) {
        return this.u26(Duration__unaryMinus_impl_x2k1y0(duration));
      }
      x26(other) {
        var diff = Duration.between(other.n1s_1, this.n1s_1);
        Companion_getInstance();
        // Inline function 'kotlin.time.Companion.seconds' call
        var this_0 = diff.seconds();
        var tmp = toDuration(this_0, DurationUnit_SECONDS_getInstance());
        Companion_getInstance();
        // Inline function 'kotlin.time.Companion.nanoseconds' call
        var this_1 = diff.nano();
        var tmp$ret$1 = toDuration(this_1, DurationUnit_NANOSECONDS_getInstance());
        return Duration__plus_impl_yu9v8f(tmp, tmp$ret$1);
      }
      y26(other) {
        return this.n1s_1.compareTo(other.n1s_1);
      }
      d(other) {
        return this.y26(other instanceof Instant_0() ? other : THROW_CCE());
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof Instant_0()) {
            tmp_0 = this.n1s_1 === other.n1s_1 || this.n1s_1.equals(other.n1s_1);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.n1s_1.hashCode();
      }
      toString() {
        return this.n1s_1.toString();
      }
    }
    initMetadataForClass($, 'Instant', VOID, VOID, [Comparable()], VOID, VOID, {0: InstantIso8601Serializer_getInstance});
    InstantClass = $;
  }
  return InstantClass;
}
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance3vjikuur3h0k4,
  Instant_0 as Instant3cn81rq2kpflk,
};
//endregion

//# sourceMappingURL=Instant.mjs.map
